import { useState, useEffect } from "react";

// const idleTimeout = 30 * 60 * 1000;

const useIdleTimer = (onIdle: () => void, idleTimeout: number) => {
  const [lastActivityTime, setLastActivityTime] = useState<number>(Date.now());

  useEffect(() => {
    // Event listeners to detect user activity
    const handleActivity = () => {
      setLastActivityTime(Date.now());
    };

    // Add event listeners for mouse move, key press, and scroll
    document.addEventListener("mousemove", handleActivity);
    document.addEventListener("keydown", handleActivity);
    document.addEventListener("scroll", handleActivity);

    // Function to check idle time
    const checkIdleTime = () => {
      if (Date.now() - lastActivityTime >= idleTimeout) {
        onIdle(); // If idle time exceeds the timeout, trigger logout
      }
    };

    // Set an interval to check for idle time every second
    const intervalId = setInterval(checkIdleTime, 1000);

    // Clean up event listeners and interval on component unmount
    return () => {
      document.removeEventListener("mousemove", handleActivity);
      document.removeEventListener("keydown", handleActivity);
      document.removeEventListener("scroll", handleActivity);
      clearInterval(intervalId);
    };
  }, [lastActivityTime, onIdle]);

  return null;
};

export default useIdleTimer;
